import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {SpineUtils} from '@fantasmagames/core/src/spine/SpineUtils';
import {ViewTypes} from '@fantasmagames/slot/src/common/view/View';
import {ObjectSize, ReelConstants} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {TimerUtils} from '@fantasmagames/core/src/update/TimerUtils';
import {GameReelConstants} from 'src/reels/GameReelConstants';

export class ReelSymbol extends PIXI.Sprite {
	protected _index: number;
	protected _animationContainer: PIXI.Container;
	protected _symbol: PIXI.Container;
	protected _spinningSymbol: PIXI.Container;
	protected _symbolBackground: PIXI.Container;
	protected _symbolForeground: PIXI.Container;
	protected _stopAnimation: SpineAnimation;
	protected _symbolType: number;

	protected _symbolContainer: PIXI.Container;
	protected _container: PIXI.Container;

	protected _spineUtils: SpineUtils;
	protected _timerUtils: TimerUtils;
	protected _viewType: ViewTypes = ReelConstants.DEFAULT_VIEW;

	protected _positionOnReel: number;
	protected _size: ObjectSize = {width: 1, height: 1};

	public init(parentSym: PIXI.Container, background?: PIXI.Container, foreground?: PIXI.Container, spinningSymbol?: PIXI.Sprite): void {
		this.setupLayersOrder(parentSym, background, foreground, spinningSymbol);
	}

	protected setupLayersOrder(parentSym: PIXI.Container, background?: PIXI.Container, foreground?: PIXI.Container, spinningSymbol?: PIXI.Sprite): void {
		this._container = new PIXI.Container();
		this.addChild(this._container);
		this._symbolContainer = new PIXI.Sprite();
		this._container.addChild(this._symbolContainer);

		if (background) {
			this._symbolContainer.addChild(background);
		}
		this._symbolContainer.addChild(parentSym);
		if (foreground) {
			this._symbolContainer.addChild(foreground);
		}

		if (spinningSymbol) {
			this._symbolContainer.addChild(spinningSymbol);
			this._spinningSymbol = spinningSymbol;
		}

		this._symbol = parentSym;
		this._symbolBackground = background;
		this._symbolForeground = foreground;
	}

	public setContainerParameters(): void {}

	public removeContainerParemeters(): void {}

	public setSymbol(symbolID: number): void {
		this.hideSymbol();
		this.hideSpinningSymbol();
		this._symbol.getChildAt(symbolID).visible = true;
		this._symbolType = symbolID;

		this.setupSymbol();

		if (this._symbolBackground) {
			this.setupBackground();
			this._symbolBackground.visible = this.hasBackground();
		}

		if (this._symbolForeground) {
			this.setupForeground();
			this._symbolForeground.visible = this.hasForeground();
		}
	}

	public setSpinningSymbol(symbolID: number): void {
		this.hideSymbol();
		this.hideSpinningSymbol();
		this._spinningSymbol.getChildAt(symbolID).visible = true;
		this._symbolType = symbolID;
	}

	public hideSymbol(): void {
		for (const child of this._symbol.children) {
			child.visible = false;
		}
	}

	public hideSpinningSymbol(): void {
		if (this._spinningSymbol) {
			for (const child of this._spinningSymbol.children) {
				child.visible = false;
			}
		}
	}

	public addAndPlayStopAnimation(anim: SpineAnimation): void {
		this.hideSymbol();
		this._stopAnimation = anim;
		this._stopAnimation.start();
		this._stopAnimation.container.position.set(ReelConstants.getSymbolSlot().width / 2, ReelConstants.getSymbolSlot().height / 2);
		this._symbolContainer.addChild(this._stopAnimation.container);
		this._stopAnimation.setOnComplete(() => {
			this.setSymbol(this._symbolType);
		});
	}

	public forceKillStopAnimation(): void {
		if (this._stopAnimation) {
			this._stopAnimation.stop();
			this.removeChild(this._stopAnimation.container);
			this.setSymbol(this._symbolType);
		}
	}

	public setSpineUtils(spineUtils: SpineUtils): void {
		this._spineUtils = spineUtils;
	}

	public setTimerUtils(timerUtils: TimerUtils): void {
		this._timerUtils = timerUtils;
	}

	protected setupBackground(): void {}

	protected setupForeground(): void {}

	protected setupSymbol(): void {}

	protected hideBackground(): void {
		for (let i = 0; i < this._symbolBackground.children.length; i++) {
			this._symbolBackground.getChildAt(i).visible = false;
		}
	}

	public makeCleanup(): void {
	}

	protected hasBackground(): boolean {
		return false;
	}

	protected hasForeground(): boolean {
		return false;
	}

	public set index(value: number) {
		this._index = value;
	}

	public get index(): number {
		return this._index;
	}

	public get animationContainer(): PIXI.Container {
		return this._animationContainer;
	}

	public set animationContainer(value: PIXI.Container) {
		this._animationContainer = value;
	}

	public get symbolType(): number {
		return this._symbolType;
	}

	public get container(): PIXI.Container {
		return this._container;
	}

	public get positionOnReel(): number {
		return this._positionOnReel;
	}

	public set positionOnReel(value: number) {
		this._positionOnReel = value;
	}

	public get size(): ObjectSize {
		return this._size;
	}

	public set size(value: ObjectSize) {
		this._size = value;
	}

	public set viewType(value: ViewTypes) {
		this._viewType = value;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/spin/ReelSymbol.ts